export default function isMainDomain(): boolean {
  return window.location.hostname.split('.')[1] === 'airtm';
}
